"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBLIC_CACHE = exports.STANDARD_CACHE = void 0;
var STANDARD_CACHE = 'i18n-cached-standard-locales';
exports.STANDARD_CACHE = STANDARD_CACHE;
var PUBLIC_CACHE = 'i18n-cached-public-locales';
exports.PUBLIC_CACHE = PUBLIC_CACHE;